export default redirectTo => (nextState, replaceState) => {
  if (__SERVER__) {
    if (typeof redirectTo === 'function') {
      replaceState(redirectTo(nextState.location));
    } else {
      replaceState(redirectTo);
    }
  }
};
